import { render, staticRenderFns } from "./InstitucionForm.vue?vue&type=template&id=7d37b71c&"
import script from "./InstitucionForm.vue?vue&type=script&lang=js&"
export * from "./InstitucionForm.vue?vue&type=script&lang=js&"
import style0 from "./InstitucionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports